// Sound. Synthesised, so there is nothing to download, nothing to cache, and
// nothing to go missing offline.
//
// The context is built on the first sound rather than at import: an
// AudioContext constructed before a user gesture starts suspended on iOS, and a
// suspended context swallows everything without an error.

import { prefs } from '../core/storage.js';

let ctx = null;

function audio() {
  if (prefs.sound === false) return null;
  if (!ctx) {
    try { ctx = new (window.AudioContext || window.webkitAudioContext)(); }
    catch { return null; }
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

function tone(freq, ms, { type = 'square', gain = 0.05, slideTo = null } = {}) {
  const ac = audio();
  if (!ac) return;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, ac.currentTime);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(slideTo, ac.currentTime + ms / 1000);
  g.gain.setValueAtTime(gain, ac.currentTime);
  // Ramp to near-zero, never to zero — exponentialRampToValueAtTime(0) throws.
  g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + ms / 1000);
  osc.connect(g).connect(ac.destination);
  osc.start();
  osc.stop(ac.currentTime + ms / 1000);
}

// Alternating pitch, so a run of pizzas sounds like eating rather than a beep
// repeated two hundred times.
let bite = 0;
export function pizza() {
  bite = 1 - bite;
  tone(bite ? 300 : 380, 55, { gain: 0.028 });
}
export const pie = () => tone(180, 260, { type: 'sawtooth', gain: 0.05, slideTo: 620 });
export const catchRaf = () => tone(520, 240, { type: 'square', gain: 0.055, slideTo: 1250 });
export const death = () => tone(420, 700, { type: 'sawtooth', gain: 0.06, slideTo: 70 });
export const levelclear = () => {
  [523, 659, 784, 1046].forEach((f, i) => setTimeout(() => tone(f, 170, { gain: 0.045 }), i * 110));
};
export const gameover = () => tone(240, 900, { type: 'triangle', gain: 0.06, slideTo: 60 });
export const start = () => {
  [392, 523, 659].forEach((f, i) => setTimeout(() => tone(f, 130, { gain: 0.04 }), i * 95));
};

const TABLE = { pizza, pie, catch: catchRaf, death, levelclear, gameover };
export function play(event) { TABLE[event]?.(); }
